const uz = {
  login: {
    subtitle: 'Mijoz kabineti',
    title: 'Kirish',
    server: 'Server',
    serverPlaceholder: 'tashkilot-nomi',
    checking: 'Tekshirilmoqda...',
    notFound: 'Tashkilot topilmadi',
    phone: 'Telefon',
    phonePlaceholder: '90 123 45 67',
    password: 'Parol',
    submit: 'Kirish',
    submitting: 'Kirilmoqda...',
  },
  catalog: {
    searchPlaceholder: 'Mahsulot qidirish...',
    allFolders: 'Barchasi',
    notFound: 'Topilmadi',
    empty: 'Bu papka bo\'sh',
    noPrice: 'Narxi yo\'q',
    addToCart: "Qo'shish",
    chooseUnit: "Birlik tanlash",
    selected: "tanlandi",
    done: "Tayyor",
    doneRemovesAll: "Barchasini 0 qilsangiz, savatdan olib tashlanadi",
  },
  cart: {
    title: 'Savat',
    empty: 'Savat bo\'sh',
    goCatalog: 'Katalogga o\'tish',
    myOrders: 'Buyurtmalarim',
    notePlaceholder: 'Izoh (ixtiyoriy)',
    total: 'Jami',
    submit: 'Buyurtma berish',
    submitting: 'Yuborilmoqda...',
    orderSent: 'Buyurtma №{number} yuborildi',
    orderError: 'Buyurtma yuborishda xato',
  },
  orders: {
    title: 'Buyurtmalarim',
    empty: 'Hali buyurtma yo\'q',
  },
  changePassword: {
    title: 'Yangi parol o\'rnating',
    hint: 'Xavfsizlik uchun standart parolni o\'zgartirishingiz kerak. Bu faqat bir marta so\'raladi.',
    newPassword: 'Yangi parol',
    confirmPassword: 'Yangi parolni takrorlang',
    tooShort: 'Parol kamida 4 ta belgidan iborat bo\'lishi kerak',
    mismatch: 'Parollar mos kelmadi',
    submit: 'Saqlash',
    submitting: 'Saqlanmoqda...',
    success: 'Parol yangilandi',
    error: 'Xato yuz berdi',
  },
  profile: {
    changePassword: "Parolni o'zgartirish",
    cancel: "Bekor qilish",
  },
  home: {
    defaultTitle: 'Mijoz kabineti',
    welcome: 'Xush kelibsiz,',
    balance: 'Balans',
    noBalance: 'Balans mavjud emas',
    weOwe: 'Sizga qarzdormiz',
    theyOwe: 'Qarzdorlik',
    cashback: 'Keshbek',
    cashbackProgramTitle: 'Keshbek dasturi',
    cashbackProgramHint: 'Xarid summasi qancha katta bo\'lsa, shuncha ko\'p foiz qaytadi',
    cashbackCurrentTier: 'Hozir shu darajadasiz',
    navHome: 'Bosh sahifa',
    navCatalog: 'Katalog',
    navCart: 'Savat',
    navAkt: 'Akt-sverka',
    navProfile: 'Profil',
    logout: 'Chiqish',
  },
  aktSverka: {
    title: 'Akt-sverka',
    period: 'Davr',
    fromDate: 'Boshlanishi',
    toDate: 'Tugashi',
    youOwe: 'Sizning qarzingiz',
    theyOwe: 'Tashkilot sizga qarzdor',
    noDebt: "Qarzdorlik yo'q",
    noTx: "Bu davrda operatsiya yo'q",
    opening: "Boshlang'ich qoldiq",
    loadError: 'Yuklashda xato',
    itemsEmpty: 'Tarkib mavjud emas',
    total: 'Jami',
    close: 'Yopish',
    share: 'Ulashish',
    shareTitle: 'Doimiy havola',
    shareHint: "Bu havola/QR kod orqali istalgan vaqt akt-sverkangizni ko'rish mumkin — masalan buxgalteringizga yuborishingiz mumkin.",
    copy: 'Nusxalash',
    copied: 'Nusxalandi',
    qrDownload: 'Yuklab olish',
    thDate: 'Sana', thDoc: 'Hujjat', thDebit: 'Debet', thCredit: 'Kredit',
    pdfDownload: 'PDF',
  },
  uomNames: {
    pcs: "dona", kg: "kilogramm", g: "gramm", t: "tonna", l: "litr", ml: "millilitr",
    m: "metr", cm: "santimetr", mm: "millimetr", "m²": "kvadrat metr", "m³": "kub metr", km: "kilometr",
    pair: "juft", roll: "rulon", box: "quti", pack: "pachka", bag: "qop", set: "to'plam",
    bottle: "shisha", can: "banka", cyl: "ballon", coil: "g'altak", spool: "g'altak (spool)", sheet: "list", bunch: "pachka",
    hr: "soat", min: "daqiqa", day: "kun", week: "hafta", month: "oy", year: "yil",
    visit: "tashrif", session: "seans", project: "loyiha", page: "sahifa", word: "so'z", trip: "reys",
  },
};
export default uz;
